export default "__VITE_ASSET__BI$ys2gg__"